
import Gameboy from "../../../assets/filled/Gameboy.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GameboyIcon({ className, dataTestid = "GameboyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Gameboy data-testid={dataTestid} className={classes} {...rest} />
  );
}
